export const getCurrencySymbol = (
  currencyName: string | undefined | null
): string => {
  if (!currencyName) return '';
  if (currencyName == 'USD') return '$';
  if (currencyName == 'EUR') return '€';
  if (currencyName == 'GBP') return '£';
  if (currencyName == 'AUD') return '$';
  return '';
};
